import { Request } from './../Shared/Request';

export class UserInfo {
    constructor(form, obj, url) {
        this.request = new Request();
        this.form = form;
        this.url = url;
        this.formFieldDefaults = {
            firstName: '',
            lastName: '',
            productionNumber: '',
            phoneNumber: '',
            emailAddress: ''
        };
        this.info = this.populateUserInformation(obj);

        if(this.info !== false) {
            this.info.then((data) => {
                this.formFieldDefaults = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    productionNumber: data.prodNum,
                    phoneNumber: data.businessPhoneNum,
                    emailAddress: data.EMailAddress
                };
            }).then(() => {
                this.form.fullName.value = this.formFieldDefaults.firstName + ' ' + this.formFieldDefaults.lastName;
                this.form.userID.value = this.formFieldDefaults.productionNumber;
                if(typeof this.form.email !== 'undefined'){
                    this.form.email.value = this.formFieldDefaults.emailAddress;
                }else if(typeof this.form.fromAddress !== 'undefined'){
                    this.form.fromAddress.value = this.formFieldDefaults.emailAddress;
                }
                this.form.prefPhoneNumber.value = this.formFieldDefaults.phoneNumber;
            })
        }

    }

    populateUserInformation(obj) {
        if(obj.id.length === 7) {
            return this.request.get(this.url + obj.id).then((resp) => {
                return JSON.parse(resp);
            })
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/modules/UserInfo/index.js